import { useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  isAdminChunkRecoveryInFlight,
  subscribeAdminChunkRecoveryInFlight,
} from './adminChunkLoadRecovery.js';
import { PwaRefreshBlockingOverlay } from './PwaRefreshBlockingOverlay.js';

/** Global blocking overlay for chunk auto-recovery (any source — not only ErrorBoundary). */
export function AdminChunkRecoveryOverlay(): JSX.Element | null {
  const { t } = useTranslation('admin');
  const [inFlight, setInFlight] = useState(() => isAdminChunkRecoveryInFlight());

  useLayoutEffect(
    () => subscribeAdminChunkRecoveryInFlight(setInFlight),
    [],
  );

  if (!inFlight) {
    return null;
  }

  return (
    <PwaRefreshBlockingOverlay
      label={t('app.chunkStaleDeploy.recovering')}
      testId="admin-chunk-recovery-overlay-global"
    />
  );
}
